module.exports = __webpack_public_path__ + "static/media/get_scientific.4d6f092b.gif";